import { AccessLevel, ICorporationResponse } from '@kcftech/prometheus-client';
import { DropdownInlineEditor } from 'components/inline_edit/DropdownInlineEditor';
import { usePermissions } from 'contexts/PermissionsContext';
import { updateCorporation } from 'utils/corporation';

export type AccessLevelDropdownProps = Readonly<{
    corporation: ICorporationResponse;
    onConfirm: (update: ICorporationResponse) => void;
}>;

const accessLevelOptions = Object.values(AccessLevel);

export function AccessLevelDropdown({
    corporation,
    onConfirm,
}: AccessLevelDropdownProps) {
    const { canEditCorporationSettings } = usePermissions();
    const onUpdateAccessLevel = async (updatedAccessLevel: AccessLevel | undefined) => {
        try {
            onConfirm(
                await updateCorporation(corporation, {
                    AccessLevel: updatedAccessLevel,
                }),
            );
        } catch {
            return 'Unable to save Access Level';
        }
        return undefined;
    };

    return (
        <DropdownInlineEditor
            value={corporation.AccessLevel}
            dropdownConfig={{
                renderItem: ({ item }) => item,
                renderLabel: ({ value }) => value,
                dataKey: (item) => item,
                popup: { width: '12rem' },
            }}
            onConfirm={onUpdateAccessLevel}
            options={accessLevelOptions}
            isDisabled={!canEditCorporationSettings}
        />
    );
}
